var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty",class:_vm.stat!=2?'':'gone'},[_c('div',{staticClass:"nodata"},[_c('img',{staticClass:"imgCls",attrs:{"src":_vm.icon}}),_c('div',{staticClass:"T3"},[_vm._v(_vm._s(_vm.getStat()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }